export default "__VITE_ASSET__DPLAS_ET__"